import React from "react";
import './KiTeaser.scss';
import teaserImage from '../../../assets/images/lovdata-pro-2-boks.svg';

export default function KiTeaser() {
	return(
		<div className="KiTeaser">
			<div className="image">
				<img src={teaserImage} alt="Lovdata Pro 2" />
			</div>
			<div className="text">
				<p>Snart kommer<br/><span className="secondary">Lovdata Pro</span> <span className="primary">2</span>...</p>
			</div>
		</div>
	)
}